module.exports = __webpack_public_path__ + "img/banner-r-shadow-2.d40d1fa9.png";